module.exports = __webpack_public_path__ + "static/media/bk-icon-tw.895d3695.svg";